export default __webpack_public_path__ + "/src/assets/images/social_purple_notext.svg";